import React, { forwardRef } from 'react';
import { Button } from '@mui/material';

const DSPrimaryButton = forwardRef<
  HTMLButtonElement,
  React.ComponentProps<typeof Button>
>((props, ref) => {
  return (
    <Button
      ref={ref}
      color="primary"
      variant="contained"
      {...props}
      sx={{
        ...props.sx,
      }}
    />
  );
});

DSPrimaryButton.displayName = 'DSPrimaryButton';

export default DSPrimaryButton;
